import { InternalContractVersionConverter } from './InternalContractVersionConverter';
import * as Translations from './VersionTranslations';
import { StackingVersionConverter } from './StackingVersionConverter';
import { IdentityVersionConverter } from './IdentityVersionConverter';

// A mapping from the source version of a model -> the next version of the model. Each major
// version bump can have an array of conversions to perform in order
const executeUpgrades: { [version: number]: Array<Translations.UpgradeExecuteCall> } = {
  0: []
};

const executeDowngrades: { [version: number]: Array<Translations.DowngradeExecuteReturn> } = {
  0: []
};

const notificationDowngrades: { [version: number]: Array<Translations.DowngradeNotification> } = {
  0: []
};

/**
 * Creates a new InternalContractVersionConverter which has the ability to upgrade and downgrade the contract between the two versions
 * which are specified. If externalMajorVersion is greater than platformMajorVersion, an error will be thrown because
 * we won't know how to do those conversions.
 *
 * @param externalMajorVersion The version of the internal api which the external module is using
 * @param platformMajorVersion The version of the internal api which the platform is using
 */
export function CreateVersionConverter(externalMajorVersion: number, platformMajorVersion: number): InternalContractVersionConverter {

  if (!Number.isInteger(externalMajorVersion) ||
    !Number.isInteger(platformMajorVersion) ||
    externalMajorVersion < 0 ||
    platformMajorVersion < 0) {

    throw new Error(`Versions must be positive integers:
    externalMajorVersion=${externalMajorVersion} platformMajorVersion=${platformMajorVersion}`);
  }

  if (externalMajorVersion > platformMajorVersion) {
    throw new Error(`External version must be less than or equal to platform version.
    externalMajorVersion=${externalMajorVersion} platformMajorVersion=${platformMajorVersion}`);
  }

  if (externalMajorVersion === platformMajorVersion) {
    // If we are using the exact same versions, just use the identity converter
    return new IdentityVersionConverter();
  }

  // Walk the span between the versions we have here and collect the upgrade and downgrades necessary
  let neededExecuteUpgrades: Array<Translations.UpgradeExecuteCall> = [];
  for (let i = externalMajorVersion; i < platformMajorVersion; i++) {
    if (i in executeUpgrades) {
      neededExecuteUpgrades.push(...executeUpgrades[i]);
    }
  }

  // Walk the span between them backwards to get the necessary downgrades
  let neededExecuteDowngrades: Array<Translations.DowngradeExecuteReturn> = [];
  let neededNotificationDowngrades: Array<Translations.DowngradeNotification> = [];
  for (let i = platformMajorVersion - 1; i >= externalMajorVersion; i--) {
    if (i in executeDowngrades) {
      neededExecuteDowngrades.push(...executeDowngrades[i]);
    }

    if (i in notificationDowngrades) {
      neededNotificationDowngrades.push(...notificationDowngrades[i]);
    }
  }

  return new StackingVersionConverter(
    externalMajorVersion, platformMajorVersion, neededExecuteUpgrades, neededExecuteDowngrades, neededNotificationDowngrades);
}



// WEBPACK FOOTER //
// ../../../src/versioning/VersionConverterFactory.ts


// WEBPACK FOOTER //
// webpack:///src/versioning/VersionConverterFactory.ts